/*------------------------------------*\
    MODULES
\*------------------------------------*/
import Alert from 'bootstrap/js/dist/alert';
import Breadcrumb from './modules/breadcrumb';
import ClickDimensionsForm from './modules/click-dimensions-form';
import Collapse from 'bootstrap/js/dist/collapse';
import CollectionsCarousel from './modules/collections-carousel';
import CollectionSelect from './modules/collection-select';
import CollectionsTour from './modules/collections-tour';
import CopyToClipboard from './modules/copy-to-clipboard';
import CountriesDropdown from './modules/countries-dropdown';
import DisplayToggle from './modules/display-toggle';
import FilterItem from './modules/filter-item';
import Filters from './modules/filters';
import Header from './modules/header';
import 'htmx.org';
import LineClamp from './modules/line-clamp';
import ListViewToggle from './modules/list-view-toggle';
import Modal from 'bootstrap/js/dist/modal';
import ModalVideo from "modal-video";
import MultiSelect from './modules/multi-select';
import Nav from './modules/nav';
import NavItem from './modules/nav-item';
import Pagination from './modules/pagination';
import ResponsiveTable from './modules/responsive-table';
import Reviews from './modules/reviews';
import Search from './modules/search';
import SelectOtherToggle from './modules/select-other-toggle';
import Share from './modules/share';
import SortDropdown from './modules/sort-dropdown';
import Tabs from './modules/tabs';
import Tooltip from 'bootstrap/js/dist/tooltip';
import TrialLoginForm from './modules/trial-login-form';
import TrialRequestForm from './modules/trial-request-form';
import TrialRequestIpInput from './modules/trial-request-ip-input';
import PageNav from './modules/page-nav';
import PartnersCarousel from './modules/partners-carousel';
import Wishlist from './modules/wishlist';
import WishlistAddForm from './modules/wishlist-add-form';
import WishlistCheckboxes from './modules/wishlist-checkboxes';

/*------------------------------------*
    APP
\*------------------------------------*/
const app = {

    init() {
        this.noJs();
        this.alwaysLoad();
        this.nodelistPolyfill();
        this.bind();
    },

    bind() {

        // Load any items that need modules
        let modulePlaceHolders = [...document.querySelectorAll('[data-module]')];

        // No modules so bail
        if (!modulePlaceHolders.length) {
            return;
        }

        modulePlaceHolders.map((item) => {

            // Attempt to load any modules
            let modules = item.getAttribute('data-module');

            if (!modules.length) {
                return false;
            }

            // Split the modules into an array
            modules = modules.trim().split(',');

            // Loop and bind to relevant modules
            modules.map((module) => {

                switch (module.trim()) {

                    case 'breadcrumb':

                        let breadcrumbInstance = new Breadcrumb(item);

                        breadcrumbInstance.init();

                        break;

                    case 'click-dimensions-form':

                        let clickDimensionsFormInstance = new ClickDimensionsForm(item);

                        clickDimensionsFormInstance.init();

                        break;

                    case 'collections-carousel':

                        let collectionsCarouselInstance = new CollectionsCarousel(item);

                        collectionsCarouselInstance.init();

                        break;

                    case 'collection-select':

                        let collectionSelectInstance = new CollectionSelect(item);

                        collectionSelectInstance.init();

                        break;

                    case 'collections-tour':

                        let collectionsTourInstance = new CollectionsTour(item);

                        collectionsTourInstance.init();

                        break;

                    case 'countries-dropdown':

                        let countriesDropdownInstance = new CountriesDropdown(item);

                        countriesDropdownInstance.init();

                        break;

                    case 'copy-to-clipboard':

                        let copyToClipboardInstance = new CopyToClipboard(item);

                        copyToClipboardInstance.init();

                        break;

                    case 'display-toggle':

                        let displayToggleInstance = new DisplayToggle(item);

                        displayToggleInstance.init();

                        break;

                    case 'filter-item':

                        let filterItemInstance = new FilterItem(item);

                        filterItemInstance.init();

                        break;

                    case 'filters':

                        let filtersInstance = new Filters(item);

                        filtersInstance.init();

                        break;
                    
                    case 'header':

                        let headerInstance = new Header(item);

                        headerInstance.init();

                        break;
                    
                    case 'line-clamp':

                        let lineClampInstance = new LineClamp(item);

                        lineClampInstance.init();

                        break;
                    
                    case 'list-view-toggle':

                        let listViewToggleInstance = new ListViewToggle(item);

                        listViewToggleInstance.init();

                        break;
                    
                    case 'multi-select':

                        let multiSelectInstance = new MultiSelect(item);

                        multiSelectInstance.init();

                        break;

                    case 'nav':

                        let navInstance = new Nav(item);

                        navInstance.init();

                        break;

                    case 'nav-item':

                        let navItemInstance = new NavItem(item);

                        navItemInstance.init();

                        break;

                    case 'pagination':

                        let paginationInstance = new Pagination(item);

                        paginationInstance.init();

                        break;

                    case 'responsive-table':

                        let responsiveTableInstance = new ResponsiveTable(item);

                        responsiveTableInstance.init();

                        break;

                    case 'reviews':

                        let reviewsInstance = new Reviews(item);

                        reviewsInstance.init();

                        break;

                    case 'search':

                        let searchInstance = new Search(item);

                        searchInstance.init();

                        break;

                    case 'select-other-toggle':

                        let selectOtherToggleInstance = new SelectOtherToggle(item);

                        selectOtherToggleInstance.init();

                        break;

                    case 'share':

                        let shareInstance = new Share(item);

                        shareInstance.init();

                        break;

                    case 'sort-dropdown':

                        let sortDropdownInstance = new SortDropdown(item);

                        sortDropdownInstance.init();

                        break;

                    case 'tabs':

                        let tabsInstance = new Tabs(item);

                        tabsInstance.init();

                        break;

                    case 'trial-login-form':

                        let trialLoginFormInstance = new TrialLoginForm(item);

                        trialLoginFormInstance.init();

                        break;

                    case 'trial-request-form':

                        let trialRequestFormInstance = new TrialRequestForm(item);

                        trialRequestFormInstance.init();

                        break;

                    case 'trial-request-ip-input':

                        let trialRequestIpInputInstance = new TrialRequestIpInput(item);

                        trialRequestIpInputInstance.init();

                        break;

                    case 'page-nav':

                        let pageNavInstance = new PageNav(item);

                        pageNavInstance.init();

                        break;

                    case 'partners-carousel':

                        let partnersCarouselInstance = new PartnersCarousel(item);

                        partnersCarouselInstance.init();

                        break;

                    case 'wishlist':

                        let wishlistInstance = new Wishlist(item);

                        wishlistInstance.init();

                        break;

                    case 'wishlist-add-form':

                        let wishlistAddFormInstance = new WishlistAddForm(item);

                        wishlistAddFormInstance.init();

                        break;

                    case 'wishlist-checkboxes':

                        let wishlistCheckboxesInstance = new WishlistCheckboxes(item);

                        wishlistCheckboxesInstance.init();

                        break;
                }
            });
        });
    },

    alwaysLoad() {
        // Tooltips
        const tooltipElems = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        const tooltipList = [...tooltipElems].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

        // Modal video
        new ModalVideo('.js-modal-video');
    },

    noJs() {
        document.documentElement.classList.remove('no-js');
        document.documentElement.classList.add('js');
    },

    nodelistPolyfill() {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = function (callback, thisArg) {
                thisArg = thisArg || window;
                for (var i = 0; i < this.length; i++) {
                    callback.call(thisArg, this[i], i, this);
                }
            };
        }
    }
};

// Launch
app.init();
